import type { IotButtonProps } from "@core/presentation/components/general/button/iot-button-base.component";
import { IotButtonBase } from "@core/presentation/components/general/button/iot-button-base.component";
import type { FC } from "react";

export type IotButtonFormProps = Omit<IotButtonProps, "htmlType">;

export const IotButtonForm: FC<IotButtonFormProps> = (props) => {
    const { type = "primary", ...restProps } = props;
    return (
        <IotButtonBase
            {...restProps}
            type={type}
            htmlType={"submit"}
        >
            {props.children}
        </IotButtonBase>
    );
};
